import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  description: 'modelRunMemberDesc',
})
export default class ModelRunMemberSerializer extends DataAPISerializer {}
